import dayIsNowDayBefore from './dayIsNowDayBefore';
import dayIsSameDay from './dayIsSameDay';
import dayIsNowDayAfter from './dayIsNowDayAfter';
import buildSbmParams from './buildSbmParams';
import findIndexToRemove from './findIndexToRemove';
import moment from 'moment-timezone';

const removeExceptionTimeBlock = (setOfBlocksToRemove, exceptionDate, availabilityOperation, exceptionsInCynoTime, SBMId) => {
    let sbmParamsObjectSet = {
        deleteDates: [],
        exceptionsSet: {},
    };
    setOfBlocksToRemove.forEach((blockSet, i) => {
        // 'i' tells us that time zone conversion has moved timeBlocks to a past day/date(0) or a future day/date(2)
        if (blockSet.length > 0) {
            if (dayIsNowDayBefore(i)) {
                let pastDate = moment(moment.utc(exceptionDate)).add(-1, 'd').format("YYYY-MM-DD");
                if (exceptionsInCynoTime[pastDate].length === 1) {
                    sbmParamsObjectSet.deleteDates.push(pastDate);
                }
                else {
                    let dayToModify = exceptionsInCynoTime[pastDate];
                    let indexToRemove = findIndexToRemove(blockSet, dayToModify);
                    dayToModify.splice(indexToRemove, 1);
                    exceptionsInCynoTime[pastDate] = dayToModify;
                    let sbmParamsObject = buildSbmParams(dayToModify, pastDate, availabilityOperation, SBMId);
                    sbmParamsObjectSet.exceptionsSet[pastDate] = sbmParamsObject;
                };
            }
            else if (dayIsSameDay(i)) {
                if (exceptionsInCynoTime[exceptionDate].length === 1) {
                    sbmParamsObjectSet.deleteDates.push(exceptionDate);
                }
                else {
                    let dayToModify = exceptionsInCynoTime[exceptionDate];
                    let indexToRemove = findIndexToRemove(blockSet, dayToModify);
                    dayToModify.splice(indexToRemove, 1);
                    exceptionsInCynoTime[exceptionDate] = dayToModify;
                    let sbmParamsObject = buildSbmParams(dayToModify, exceptionDate, availabilityOperation, SBMId);
                    sbmParamsObjectSet.exceptionsSet[exceptionDate] = sbmParamsObject;
                };
            }
            else if (dayIsNowDayAfter(i)) {
                let nextDate = moment(moment.utc(exceptionDate)).add(1, 'd').format("YYYY-MM-DD");
                if (exceptionsInCynoTime[nextDate].length === 1) {
                    sbmParamsObjectSet.deleteDates.push(nextDate);
                }
                else {
                    let dayToModify = exceptionsInCynoTime[nextDate];
                    let indexToRemove = findIndexToRemove(blockSet, dayToModify);
                    dayToModify.splice(indexToRemove, 1);
                    exceptionsInCynoTime[nextDate] = dayToModify;
                    let sbmParamsObject = buildSbmParams(dayToModify, nextDate, availabilityOperation, SBMId);
                    sbmParamsObjectSet.exceptionsSet[nextDate] = sbmParamsObject;
                };
            };
        };
    });
    return [sbmParamsObjectSet, exceptionsInCynoTime];
};

export default removeExceptionTimeBlock;


// WEBPACK FOOTER //
// ./src/js/containers/ProviderContainer/utils/removeExceptionTimeBlock.js